
<template>
  <div class="app-container">
    <HeaderLogo />
    <div class="main-content">
      <div class="card">
        <div class="terminal-header">
          <h2>{{ group.name }}</h2>
          <div class="status-box">
          
          </div>
        </div>

        <div class="terminal-body">
          <div class="row">
            <span></span>
            <strong>定时任务配置</strong>
          </div>

          <div class="row" style="margin-top: 12px;">
            <span class="label"></span>
            <div class="time-config">
              <div class="time-row">
                <span>发送录音:</span>
                <input v-model="noonStart" type="time" />
                <span class="dash">-</span>
                <input v-model="noonEnd" type="time" />
                <button class="btn btn-ghost" @click="saveNoon">
                  设置发送录音时间
                </button>
              </div>
              <div class="time-row">
                <span>停止录音:</span>
                <input v-model="nightStart" type="time" />
                <span class="dash">-</span>
                <input v-model="nightEnd" type="time" />
                <button class="btn btn-ghost" @click="saveNight">
                  设置停止录音时间
                </button>
              </div>
            </div>
          </div>

          <p class="desc">
          通过设定时间段，终端设备将在指定的时间内自动录音或停止录音，并在录音期间通过人声识别触发报警。
          </p>

          <!-- <AudioPlayer default-file="record00001.wav" /> -->

          <div class="bottom-actions">
           
            <span class="link-back" @click="$router.back()">
              返回到上一页
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
import {getExistingWsClient } from '@/utils/wsInstance'
import { getTaskByGroupId,updateTaskTime} from '@/api/api'
export default {
  name: 'TerminalStatus',
  components: { HeaderLogo, AudioPlayer },
 props: {
 group: {
    type: Object,
    default: () => ({}) // 默认值设置为一个空对象
  }
},

  data() {
    return {
      online: true,
      ip: '192.168.1.200',
      noonId:null,
      nightId:null,
      noonStart: '',
      noonEnd: '',
      nightStart: '',
      nightEnd: '',
      wsClient: null
    }
  },
  computed: {
   
  },
  mounted() {
    this.wsClient = getExistingWsClient()
    if (!this.wsClient) {
      return
    }
   this.findTask()
  },
  methods: {

 async findTask() {
  try {
    console.log(this.group);

    const res = await getTaskByGroupId(this.group.deviceGroupId);
    console.log(res)
    if (res.code === 0 && Array.isArray(res.data)) {
      // 初始化默认值
      this.noonStart = '';
      this.noonEnd = '';
      this.nightStart = '';
      this.nightEnd = '';
      this.noonId = null;
      this.nightId = null;

      for (const d of res.data) {
        if (d.taskType === 'NOON') {
          this.noonStart = d.startTime;
          this.noonEnd = d.endTime;
          this.noonId = d.id
        } else if (d.taskType === 'NIGHT') {
          this.nightStart = d.startTime;
          this.nightEnd = d.endTime;
          this.nightId = d.id
        }
      }
        console.log("this.noonStart")
      console.log(this.noonStart)
    }
  } catch (err) {
    console.error('获取任务失败:', err);
  }
},

    toggleOnline() {
      this.online = !this.online
    },
  async saveNoon() {
  try {
    // ✅ 校验任务ID
    if (!this.noonId) {
      alert("任务不存在或尚未创建！");
      return;
    }

    // ✅ 校验时间
    // if (!this.noonStart || !this.noonEnd) {
    //   alert("时间格式无效，请检查开始和结束时间");
    //   return;
    // }

    // ✅ 参数对象
    const form = {
      deviceGroupId: this.group.deviceGroupId,
      taskId: this.noonId,
      startTime: this.noonStart,
      endTime: this.noonEnd
    };

    // ✅ 发起更新请求
    const res = await updateTaskTime(form);

    // ✅ 响应结果处理
    if (res.code === 0) {
      alert("时间已更新！");
    } else {
     
    }
  } catch (err) {
  
    alert("更新失败，请检查网络或服务器状态。");
  }
},

   async saveNight() {
       try {
    // ✅ 校验任务ID
    if (!this.nightId) {
      alert("任务不存在或尚未创建！");
      return;
    }

    // ✅ 校验时间
    // if (!this.nightStart || !this.nightEnd) {
    //   alert("时间格式无效，请检查开始和结束时间");
    //   return;
    // }

    // ✅ 参数对象
    const form = {
      deviceGroupId: this.group.deviceGroupId,
      taskId: this.nightId,
      startTime: this.nightStart,
      endTime: this.nightEnd
    };

    // ✅ 发起更新请求
    const res = await updateTaskTime(form);

    // ✅ 响应结果处理
    if (res.code === 0) {
      alert("时间已更新！");
    } else {
     
    }
  } catch (err) {
    console.log(err)
    alert("更新失败，请检查网络或服务器状态。");
  }
    
    },
    goAlarms() {
      this.$router.push({
        name: 'AlarmRecords',
        params: { group: this.group }
      })
    }
  }
}
</script>

<style scoped>
.terminal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  gap: 12px;
}

.terminal-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #f9fafb;
}

.status-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 6px;
  color: #e5e7eb;
}

.terminal-body .row {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin-top: 6px;
  color: #e5e7eb;
}

.label {
  margin-right: 4px;
  padding-top: 6px;
}

.time-config {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 0px;
  width: 100%;
  max-width: 520px;
}

.time-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.dash {
  margin: 0 2px;
}

.desc {
  margin: 16px 0px;
  font-size: 13px;
  color: #9ca3af;
}

.bottom-actions {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .terminal-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .terminal-header h2 {
    font-size: 18px;
  }
  .terminal-body .row {
    flex-direction: column;
    align-items: flex-start;
  }
  .time-config {
    margin-left: 0;
  }
  .bottom-actions .btn {
    width: 100%;
  }
}
</style>
